import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Ginger } from './botanical/Ginger';
export function NewBonos() {
  const bonos = [{
    title: 'Botiquín Natural Express',
    value: '$4.999 ARS'
  }, {
    title: 'Guía Rápida Qué Hacer Primero',
    value: '$3.999 ARS'
  }, {
    title: 'Lista de Compras Hogar Natural',
    value: '$2.999 ARS'
  }, {
    title: 'Calendario 7 Días de Hábitos Naturales',
    value: '$3.999 ARS'
  }, {
    title: 'Mini Guía Familiar de Remedios Naturales',
    value: '$4.999 ARS'
  }];
  return <Section className="bg-forest-mist relative overflow-hidden py-20" data-id="element-77">
      <Ginger className="absolute top-20 -left-16 w-64 h-64 text-moss opacity-10 blur-[2px] rotate-12 pointer-events-none" aria-hidden="true" data-id="element-78" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-79">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-forest-deep text-center mb-12" data-id="element-80">
          Además recibís estos 5 bonos sin costo adicional
        </h2>

        <div className="space-y-4 mb-12" data-id="element-81">
          {bonos.map((bono, idx) => <Card key={idx} className="px-5 py-4 bg-white shadow-sm border-sage-mist flex items-center justify-between gap-4" data-id="element-82">
              <div className="flex items-center gap-3" data-id="element-83">
                <span className="text-xl shrink-0" data-id="element-84">🎁</span>
                <h3 className="font-bold text-forest-deep leading-tight" data-id="element-85">
                  {bono.title}
                </h3>
              </div>
              <span className="text-sm font-bold text-moss whitespace-nowrap" data-id="element-86">
                {bono.value} <span className="text-moss" data-id="element-87">INCLUIDO</span>
              </span>
            </Card>)}
        </div>

        <div className="text-center" data-id="element-88">
          <p className="text-xl font-bold text-forest-deep bg-white/60 inline-block px-8 py-4 rounded-2xl border border-sage-mist shadow-sm" data-id="element-89">
            VALOR TOTAL: $20.995 ARS — INCLUIDOS SIN COSTO ADICIONAL
          </p>
        </div>
      </div>
    </Section>;
}